// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.employees .page-data-section__heading {\n  padding: 20px 20px 0;\n}\n@media (max-width: 1024px) {\n.employees .page-data-section__heading {\n    padding: 15px 15px 0;\n}\n}\n", ""]);
// Exports
module.exports = exports;
